import React, { useState, useContext } from "react";
import Container from "../components/Container";
import Button from "../components/Button";
import AuthCard from "../components/AuthCard";
import AuthHeader from "../components/AuthHeader";
import InputField from "../components/InputField";
import CheckboxField from "../components/CheckboxField";
import AuthLink from "../components/AuthLink";
import Divider from "../components/Divider";
import GoogleButton from "../components/GoogleButton";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function Register() {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    function: "",
    acceptTerms: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const navigate = useNavigate();
  const { registerUser, loading } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      toast.error("Les mots de passe ne correspondent pas");
      return;
    }
    if (!formData.acceptTerms) {
      toast.error("Vous devez accepter les conditions d'utilisation");
      return;
    }
    const payload = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email,
      password: formData.password,
      password_confirmation: formData.confirmPassword,
      phone: formData.phone,
      function: formData.function,
      terms: formData.acceptTerms,
    };
    const res = await registerUser(payload);
    if (res?.ok) {
      toast.success("Inscription réussie");
      navigate("/applications");
    } else {
      const errorObj = JSON.parse(res.error);
      toast.error(errorObj?.message || "Erreur lors de l'inscription");
    }
  };

  const handleGoogleRegister = () => {
    console.log("Google register");
  };

  return (
    <Container className="min-h-screen bg-gradient-to-br from-[#E9FBF8] via-white to-[#FFEFD8] bg-bg-login bg-contain bg-bottom flex items-center justify-center py-6">
      <AuthCard>
        <AuthHeader />

        <form className="mt-4 space-y-4" onSubmit={handleSubmit}>
          <InputField
            label="Prénom"
            type="text"
            name="first_name"
            value={formData.first_name}
            onChange={handleChange}
            required
          />

          <InputField
            label="Nom"
            type="text"
            name="last_name"
            value={formData.last_name}
            onChange={handleChange}
            required
          />

          <InputField
            label="Email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <div>
            <label className="block text-[14px] font-medium text-[#1B1C33]">
              Mot de passe
            </label>
            <div className="relative mt-2.5">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="w-full rounded-[7px] border border-[#C1BECE] px-4 py-2 text-[14px] focus:outline-none focus:ring-2 focus:ring-[#FEA12B]/60 pr-10"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#1B1C33] hover:text-[#FEA12B] transition-colors"
              >
                {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
              </button>
            </div>
          </div>

          <div>
            <label className="block text-[14px] font-medium text-[#1B1C33]">
              Confirmation de mot de passe
            </label>
            <div className="relative mt-2.5">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                className="w-full rounded-[7px] border border-[#C1BECE] px-4 py-2 text-[14px] focus:outline-none focus:ring-2 focus:ring-[#FEA12B]/60 pr-10"
                required
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#1B1C33] hover:text-[#FEA12B] transition-colors"
              >
                {showConfirmPassword ? (
                  <FaEyeSlash size={18} />
                ) : (
                  <FaEye size={18} />
                )}
              </button>
            </div>
          </div>

          <InputField
            label="Numéro de téléphone"
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />

          <InputField
            label="Fonction"
            type="text"
            name="function"
            value={formData.function}
            onChange={handleChange}
            required
          />

          <CheckboxField
            id="terms"
            label="J'accepte les"
            linkText="Conditions d'utilisation"
            checked={formData.acceptTerms}
            onChange={handleChange}
            name="acceptTerms"
          />

          <div className="flex pt-5 justify-center">
            <Button
              type="submit"
              className="w-full py-2 text-[14px]"
              disabled={loading}
            >
              {loading ? "Inscription..." : "S'inscrire"}
            </Button>
          </div>
        </form>

        <AuthLink text="J'ai déjà un" linkText="Compte ?" to="/login" />

        <Divider className="mt-6" />

        <GoogleButton onClick={handleGoogleRegister} />
      </AuthCard>
    </Container>
  );
}
